// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__Okins","contactHead":"styles_contactHead__1r2iG","def":"styles_def__ZJp-B"};